<!-- Header -->
<div class="frontpage-widget cover-image-trees-gray">
    <div class="whitebox dark-blue">
        <div class="container">
            <p class="text-muted">
                SCREENING
                <i class="fa fa-chevron-right"></i>
            </p>
            <h2 i18n>Foreløbig screening</h2>
            <p i18n>
                <span class="text-muted">Lokalitetsnummer: </span>{{location.number}}
            </p>
            <p *ngIf="location.isLandfill" i18n>Losseplads</p>
        </div>
    </div>
</div>

<!-- location data -->
<div class="container">
    <div *ngIf="loading" class="mt-5 text-center">
        <app-load-indicator style="width: 25px; height: 25px;"></app-load-indicator>
        <h3 class="vd-text-muted font-weight-light mb-0 mt-1" i18n>Henter lokalitet... </h3>
        <p class="text-muted mt-1">Det tager et øjeblik</p>
    </div>

    <div *ngIf="!loading && !preliminaryScreeningLocationDetails.hasV2Polygon && !preliminaryScreeningLocationDetails.hasV1Polygon"
        class="col-sm-12 col-lg-12 mb-5 mt-5 text-center">
        <img style="width:6rem" src="assets/undraw_no_data_qbuo.svg">
        <h6 class="text-muted mt-3" i18n>Denne lokalitet indeholder ingen data :(</h6>
    </div>
    <div [hidden]="loading" *ngIf="preliminaryScreeningLocationDetails.hasV2Polygon || preliminaryScreeningLocationDetails.hasV1Polygon">
        <div class="row mt-5">
            <div class="col-sm-12 col-lg-3">
                <div *ngIf="loading" class="vd-card screening-result p-4 text-center">
                    <h5 class=" text-muted"><i class="fa fa-spinner fa-spin"></i> Indlæser...</h5>
                </div>
                <div *ngIf="!loading && showV2LocationDetails" class="vd-card screening-result p-4 mb-4">
                    <!-- V2 polygon data -->
                    <div>
                        <div class="form-group">
                            <div class="result-value">
                                <h5 i18n>{{ getLeftBoxTitle() }}</h5>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Screeningsresultat:</label>
                            <div class="result-value">
                                <div class="risk-indicator-screening"
                                    [ngClass]="{
                                    'no-risk': (!preliminaryScreeningLocationDetails.v2PolygonResult.hasData || preliminaryScreeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.NoRisk),
                                    'risk': preliminaryScreeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.Risk,
                                    'olie-benzin': preliminaryScreeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.OlieOgBenzinprodukter}">

                                </div>
                                <span i18n>
                                    Maksimal overskridelse:
                                    <b
                                        [ngClass]="{'text-danger':(preliminaryScreeningLocationDetails.v2PolygonResult.hasData && preliminaryScreeningLocationDetails.v2PolygonResult.factor > 1)}">
                                        <span
                                            *ngIf="preliminaryScreeningLocationDetails.v2PolygonResult.hasData && !isNaN(preliminaryScreeningLocationDetails.v2PolygonResult.factor)">
                                            {{preliminaryScreeningLocationDetails.v2PolygonResult.factor | number:'1.0-1'}}
                                        </span>
                                        <span
                                            *ngIf="!preliminaryScreeningLocationDetails.v2PolygonResult.hasData || isNaN(preliminaryScreeningLocationDetails.v2PolygonResult.factor)">-</span>
                                    </b>
                                </span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Risikovurdering:</label>

                            <ng-container *ngIf="!preliminaryScreeningLocationDetails.v2PolygonResult.hasData">
                                <div><span class="text-muted">Utilstrækkeligt vurderingsgrundlag</span></div>
                            </ng-container>

                            <ng-container *ngIf="preliminaryScreeningLocationDetails.v2PolygonResult.hasData">
                                <div class="result-value">
                                    <span class="text-muted"
                                        *ngIf="preliminaryScreeningLocationDetails.v2PolygonResult.reassessment" i18n>
                                        Lokaliteten er revurderet til:
                                    </span>

                                    <span
                                        *ngIf="preliminaryScreeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.NoRisk">
                                        <b>Ingen risiko</b>
                                    </span>
                                    <span
                                        *ngIf="preliminaryScreeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.Risk">
                                        <b i18n>Risiko</b>
                                    </span>
                                    <span
                                        *ngIf="preliminaryScreeningLocationDetails.v2PolygonResult.polygonStatus == screeningPolygonStatus.OlieOgBenzinprodukter">
                                        <b i18n>Olie- og benzinprodukter</b>
                                    </span>
                                </div>
                            </ng-container>
                        </div>

                        <div class="form-group"
                            *ngIf="preliminaryScreeningLocationDetails.v2PolygonResult.reassessment != null">
                            <label for="polutant">Revurderet af:</label>
                            <div class="text-muted">
                                <i class="fa fa-user"></i>
                                {{preliminaryScreeningLocationDetails.v2PolygonResult.reassessment.caseWorker.name}}
                                <span class="ml-2  ">
                                    <i class="fa fa-comment"></i>
                                    <span class="bg-light">
                                        <b>"</b>
                                        <span>{{reassessmentEllipsisComment(preliminaryScreeningLocationDetails.v2PolygonResult)}}</span>
                                        <b>"</b>
                                    </span>
                                </span>
                            </div>
                        </div>

                        <div class="form-group">
                            <a [routerLink]="['/riskassessment/preliminary/location-details', location.id]">
                                Se lokalitet i Risikovurdering
                            </a>
                        </div>
                    </div>
                </div>

                <div *ngIf="!loading && showV1LocationDetails" class="vd-card screening-result p-4">
                    <!-- V1 polygon data -->
                    <div>
                        <div class="form-group">
                            <div class="result-value">
                                <h5 i18n>{{ getLeftBoxTitle() }}</h5>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Screeningsresultat:</label>
                            <div class="result-value">
                                <div class="risk-indicator-screening"
                                    [ngClass]="{
                                    'no-risk': (!preliminaryScreeningLocationDetails.v1PolygonResult.hasData || preliminaryScreeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.NoRisk),
                                    'risk': preliminaryScreeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.Risk,
                                    'olie-benzin': preliminaryScreeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.OlieOgBenzinprodukter}">
                                </div>

                                <span i18n>
                                    Maksimal overskridelse:
                                    <b
                                        [ngClass]="{'text-danger':(preliminaryScreeningLocationDetails.v1PolygonResult.hasData && preliminaryScreeningLocationDetails.v1PolygonResult.factor > 1)}">
                                        <span
                                            *ngIf="preliminaryScreeningLocationDetails.v1PolygonResult.hasData && !isNaN(preliminaryScreeningLocationDetails.v1PolygonResult.factor)">
                                            {{preliminaryScreeningLocationDetails.v1PolygonResult.factor | number:'1.0-2'}}
                                        </span> <span
                                            *ngIf="!preliminaryScreeningLocationDetails.v1PolygonResult.hasData || isNaN(preliminaryScreeningLocationDetails.v1PolygonResult.factor)">-</span>
                                    </b>
                                </span>
                            </div>
                        </div>

                        <div class="form-group">
                            <label for="polutant">Risikovurdering:</label>
                            <ng-container *ngIf="!preliminaryScreeningLocationDetails.v1PolygonResult.hasData">
                                <div><span class="text-muted">Utilstrækkeligt vurderingsgrundlag</span></div>
                            </ng-container>

                            <ng-container *ngIf="preliminaryScreeningLocationDetails.v1PolygonResult.hasData">
                                <div class="result-value">
                                    <span class="text-muted"
                                        *ngIf="preliminaryScreeningLocationDetails.v1PolygonResult.reassessment != null" i18n>
                                        Lokaliteten er revurderet til:
                                    </span>

                                    <span
                                        *ngIf="preliminaryScreeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.NoRisk">
                                        <b>Ingen risiko</b>
                                    </span>
                                    <span
                                        *ngIf="preliminaryScreeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.Risk">
                                        <b i18n>Risiko</b>
                                    </span>
                                    <span
                                        *ngIf="preliminaryScreeningLocationDetails.v1PolygonResult.polygonStatus == screeningPolygonStatus.OlieOgBenzinprodukter">
                                        <b i18n>Olie- og benzinprodukter</b>
                                    </span>
                                </div>
                            </ng-container>
                        </div>

                        <div class="form-group" *ngIf="preliminaryScreeningLocationDetails.v1PolygonResult.reassessment != null">
                            <label for="polutant">Revurderet af:</label>
                            <div class="text-muted">
                                <i class="fa fa-user"></i>
                                {{preliminaryScreeningLocationDetails.v1PolygonResult.reassessment.caseWorker.name}}
                                <span class="ml-2  ">
                                    <i class="fa fa-comment"></i> <span
                                        class="bg-light"><b>"</b><span>{{reassessmentEllipsisComment(preliminaryScreeningLocationDetails.v1PolygonResult)}}</span><b>"</b></span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="col-lg-9 ml-0 pl-0">
                <div>
                    <div class="row ml-4">
                        <div class="col-lg-6 form-group mb-1 pl-0">
                            <h5 for="polutant">Flag:</h5>
                        </div>
                        <div class="col-lg-6"></div>
                    </div>

                    <div class="row ml-4 mb-4">
                        <div *ngIf="!hasAnyFlags()">
                            <span class="text-muted">
                                <i class="fa fa-thumbs-up fa-lg"></i>
                                Ingen flag på denne lokalitet
                            </span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Bly_kobber_eller_PAH)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Bly, kobber eller PAH fjernet i trin 1</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Kompleks_geologi)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Område med kompleks geologi</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Manglende_modelstof)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Et eller flere forureningsstoffer mangler et modelstof</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Svag_geologi)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Svag datadækning for bestemmelse af dæklagstykkelser</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.MTBE_fjernet)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>MTBE fjernet</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Boring_uden_ler)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>Lokalitet har boring uden ler i en radius af 100-300 m fra kant</span>
                        </div>
                        <div class="col-lg-6 pl-0" *ngIf="hasFlag(screeningFlag.Risiko_pga_vandindvinding)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>
                                Lokalitet udgør en risiko fordi der ligger en vandindvindingsboring indenfor 100 m
                            </span>
                        </div>
                        <div class="col-lg-6 pl-0"
                            *ngIf="hasFlag(screeningFlag.Kun_Olie_Benzin_Stoffer)">
                            <i class="fa fa-flag text-danger"></i>
                            <span i18n>
                                Lokalitet er udelukkende forurenet med olie- og benzin stoffer
                            </span>
                        </div>
                    </div>

                    <!-- Tables of screenings -->
                    <!-- V2 -->
                    <div class="row mt-3 mb-5 ml-2" *ngIf="preliminaryScreeningLocationDetails.hasV2Polygon">
                        <ng-container [ngTemplateOutlet]="tmplPolygonType"
                            [ngTemplateOutletContext]="{pType: polygonType.V2, screeningResults: v2ScreeningResults}">
                        </ng-container>
                    </div>
                    <!-- V1 -->
                    <div class="row mt-3 mb-5 ml-2" *ngIf="preliminaryScreeningLocationDetails.hasV1Polygon">
                        <ng-container [ngTemplateOutlet]="tmplPolygonType"
                            [ngTemplateOutletContext]="{pType: polygonType.V1, screeningResults: v1ScreeningResults}">
                        </ng-container>
                    </div>

                </div>
            </div>
        </div>

    </div>

    <button #showScreeningHistoryButton style="display:none;" data-toggle="modal"
        data-target="#screeningHistory"></button>
</div>

<div class="modal fade" id="reassessModal" tabindex="-1" role="dialog" aria-labelledby="reassessModalLabel"
    aria-hidden="true">
    <div class="modal-dialog">
        <div class="modal-content">

            <div class="modal-body pt-5 px-5 pb-3">
                <h5 i18n>Revurder lokation</h5>
                <p *ngIf="reassessToStatus == screeningPolygonStatus.NoRisk">
                    Denne lokation er vurderet til
                    <u>ikke</u> at udgøre en risiko og er ikke tilgængelig i den endelige risikovurdering. Ved at
                    revurdere
                    lokationen gøres den tilgængelig for risikovurdering.
                </p>

                <p *ngIf="reassessToStatus == screeningPolygonStatus.Risk">
                    Denne lokation er vurderet til at udgøre en risiko og er dermed
                    <u>tilgængelig</u> i den endelige risikovurdering. Ved at revurdere lokationen vil den
                    <u>ikke længere</u> være tilgængelig for risikovurdering.
                </p>

                <div class="form-group pt-4">
                    <label for="exampleFormControlTextarea1">Giv en begrundelse for revurdering:</label>
                    <textarea [(ngModel)]="reassessRemark" class="form-control" id="exampleFormControlTextarea1"
                        placeholder="Skriv begrundelse..." rows="3"></textarea>
                </div>

                <div *ngIf="missingRemark">
                    <p class="text-danger">*Bemærkning er påkrævet</p>
                </div>
            </div>
            <div class="modal-footer pb-5 px-5 pt-4">
                <button id="reasessModalCloseButton" type="button" class="btn btn-secondary" data-dismiss="modal"
                    #reasessModalCloseButton>
                    Fortryd
                </button>

                <button type="button" class="btn btn-dark" style="width: 12rem" (click)="reassess()">

                    <span style="pointer-events: none"
                        *ngIf="!loading && reassessToStatus == screeningPolygonStatus.NoRisk">
                        <i class="fa fa-check"></i> Revurder (til 'risiko')
                    </span>
                    <span style="pointer-events: none"
                        *ngIf="!loading && reassessToStatus == screeningPolygonStatus.Risk">
                        <i class="fa fa-check"></i> Revurder (til 'ingen risiko')
                    </span>
                    <span *ngIf="loading">
                        <i class="fa fa-spinner fa-spin"></i>
                    </span>
                </button>
            </div>
        </div>
    </div>
</div>

<div class="modal fade" id="preliminaryModal" tabindex="-1" role="dialog" aria-labelledby="preliminaryModal"
    aria-hidden="true">
    <div class="modal-dialog" role="document">
        <div class="modal-content">

            <div class="modal-body pt-5 px-5 pb-3">
                <h5 i18n>Foreløbig risikovurdering </h5>
                <p i18n>
                    Denne lokalitet er kun V1 screenet. Det er muligt at foretage indledende beregninger, men disse kan
                    ikke ophøjes til gældende
                    risikovurderinger.
                </p>


                <div class="form-group pt-4">
                    <label for="exampleFormControlTextarea1">Giv en begrundelse for foreløbig undersøgelse:</label>
                    <textarea [(ngModel)]="reassessRemark" class="form-control" id="exampleFormControlTextarea1"
                        placeholder="Skriv begrundelse..." rows="3"></textarea>
                </div>
            </div>
            <div class="modal-footer pb-5 px-5 pt-4">
                <button type="button" class="btn btn-secondary" data-dismiss="modal">Fortryd</button>

                <button type="button" class="btn btn-dark" data-dismiss="modal">
                    Fortsæt
                </button>
            </div>
        </div>
    </div>
</div>

<!-- screening results group by polygon type and area -->
<ng-template #tmplPolygonType let-pType="pType" let-screeningResults="screeningResults">
    <ng-container *ngFor="let resultKey of getObjectKeys(screeningResults); let index = index;">
        <div class="col-sm-12 col-lg-12 mb-4">
            <h4 class="d-inline-block">
                {{polygonType[pType]}} - {{ resultKey | number:'1.2-2' }} m<sup>2</sup> - Screeningsresultater</h4>
            <hr />
            <ng-container [ngTemplateOutlet]="tmpScreeningResults"
                [ngTemplateOutletContext]="{cTranslationType: compoundTranslationType.Pollutant, screeningResults: filterScreeningResults(screeningResults[resultKey], compoundTranslationType.Pollutant)}">
            </ng-container>
            <ng-container [ngTemplateOutlet]="tmpScreeningResults"
                [ngTemplateOutletContext]="{cTranslationType: compoundTranslationType.PollutionCause, screeningResults: filterScreeningResults(screeningResults[resultKey], compoundTranslationType.PollutionCause)}">
            </ng-container>
            <ng-container [ngTemplateOutlet]="tmpScreeningResults"
                [ngTemplateOutletContext]="{cTranslationType: compoundTranslationType.Activity, screeningResults: filterScreeningResults(screeningResults[resultKey], compoundTranslationType.Activity)}">
            </ng-container>
        </div>
    </ng-container>
</ng-template>

<!-- ScreeningResults template -->
<ng-template #tmpScreeningResults let-cTranslationType="cTranslationType" let-screeningResults="screeningResults">
    <ng-container *ngIf="screeningResults.length > 0">
        <ng-container [ngSwitch]="cTranslationType">
            <h5 class="font-italic mb-0 mt-1" *ngSwitchCase="compoundTranslationType.Pollutant">Stoffer</h5>
            <h5 class="font-italic mb-0 mt-1" *ngSwitchCase="compoundTranslationType.PollutionCause">Brancher</h5>
            <h5 class="font-italic mb-0 mt-1" *ngSwitchCase="compoundTranslationType.Activity">Aktiviteter</h5>
        </ng-container>

        <table class="table table-striped table-hover">
            <thead>
                <tr>
                    <th>Dato</th>
                    <ng-container [ngSwitch]="cTranslationType">
                        <ng-container *ngSwitchCase="compoundTranslationType.Pollutant">
                            <th>Stofnavn</th>
                            <th>Kildestørrelse</th>
                        </ng-container>
                        <ng-container class="font-italic mb-0 mt-1"
                            *ngSwitchCase="compoundTranslationType.PollutionCause">
                            <th>Branche</th>
                            <th>Kildestørrelse</th>
                            <th>Stofnavn</th>
                        </ng-container>
                        <ng-container class="font-italic mb-0 mt-1" *ngSwitchCase="compoundTranslationType.Activity">
                            <th>Aktiviteter </th>
                            <th>Kildestørrelse</th>
                            <th>Stofnavn</th>
                        </ng-container>
                    </ng-container>
                    <th>Stofkilde</th>
                    <th>Kvalitetskriterie</th>
                    <th> <small class="text-muted">Worst case</small><br> Koncentration </th>
                    <th> <small class="text-muted">100m nedstrøms</small><br> Koncentration </th>
                    <th>Årsag til frasortering</th>
                    <th>Faktor</th>
                    <th></th>
                </tr>
            </thead>
            <tbody>
                <ng-container *ngFor="let result of screeningResults">
                    <tr [routerLink]="['/screening/preliminary/compound-details', result.id]">
                        <td>{{result.createdAt | date:'d/M-yyyy HH:mm'}}</td>
                        <ng-container [ngSwitch]="cTranslationType">
                            <ng-container *ngSwitchCase="compoundTranslationType.Pollutant">
                                <td>{{result.compoundName}}</td>
                                <td>{{result.sourceSize | number:'1.2-2'}}</td>
                            </ng-container>
                            <ng-container class="font-italic mb-0 mt-1"
                                *ngSwitchCase="compoundTranslationType.PollutionCause">
                                <td>{{result.industry?.name}}</td>
                                <td>{{result.sourceSize | number:'1.2-2'}}</td>
                                <td>{{result.compoundName}}</td>
                            </ng-container>
                            <ng-container class="font-italic mb-0 mt-1"
                                *ngSwitchCase="compoundTranslationType.Activity">
                                <td>{{result.activity?.name}}</td>
                                <td>{{result.sourceSize | number:'1.2-2'}}</td>
                                <td>{{result.compoundName}}</td>
                            </ng-container>
                        </ng-container>

                        <td>{{getCompoundOriginText(result.compoundOrigin)}}</td>
                        <td>{{getQualityCriterium(result?.qualityCriterion)}}
                            <span *ngIf="result?.qualityCriterion > 0">μg/L</span>
                        </td>
                        <td>{{getNumberWithSignificantDigits(result.worstCaseConcentration)}} μg/L</td>
                        <td>{{getNumberWithSignificantDigits(result.concentrationDownstream)}} μg/L</td>
                        <td>
                            <i *ngIf="result.removalReason === ''" class="fa fa-minus"></i>
                            {{getRemovalReason(result.removalReason)}}
                        </td>
                        <td>
                            <b [ngClass]="{'text-danger': result.factor > 1}">
                                {{ getFactor(result.factor, result.qualityCriterion, result.concentrationDownstream) }}
                            </b>
                        </td>
                        <td>
                            <span *ngIf="result.flag > 0 && hasFlag(result.flag)">
                                <i class="fa fa-flag text-danger"></i>
                            </span>
                            <span *ngIf="result.flag === 0 || !hasFlag(result.flag)"> - </span>
                        </td>
                    </tr>
                </ng-container>

            </tbody>
        </table>
    </ng-container>
</ng-template>
